export interface Login { 
  email?: string;
  cpf: string;
  senha: string;
}

export interface OpenAccountForm {
  nome: string;
  cpf: string;
  dataNasc: string;
  telefone: string;
  email: string;
}

export interface LoginResponse extends Login { 
  id: number;
  nomeUsuario: string;
}

export interface TokenResponse {
  tokenValue: string,
  idUsuario: number
}